import React from "react";
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { Autoplay } from 'swiper/modules';
import apple from '../img/icons8-apple-fruit-64.png';
import banana from '../img/icons8-banana-100.png';
import grapes from '../img/icons8-grapes-64.png';
import mango from '../img/icons8-mango-64.png';
import orange from '../img/icons8-orange-100.png';
import guava from '../img/icons8-guava-96.png';
import pomegranate from '../img/icons8-pomegranate-100.png';
import papaya from '../img/icons8-papaya-64.png';
import coconut from '../img/icons8-coconut-64.png';
import lemon from '../img/icons8-citrus-96.png';
import pineapple from '../img/icons8-pineapple-100.png';


function Banner(){
    return(<>
           
        <div className="container mb-5 mt-5 pb-3 ">
        <Swiper
        slidesPerView={1}
        spaceBetween={10}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
        modules={[Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 ">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={apple} class="img-fluid rounded-start mx-auto d-block" alt="apple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start mb-0 lead text-muted fw-bold">Fresh Apple </h5>
                 <p className=" text-start"><small className="text-muted">Crisp and sweet, a classic fruit.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={banana} class="img-fluid rounded-start mx-auto d-block" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead mb-0 fw-bold text-muted">Fresh Banana </h5>
                <p className=" text-start"><small className="text-muted">Yellow and portable, a potassium-packed snack..</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={orange} class="img-fluid rounded-start mx-auto d-block" alt="orange" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead fw-bold mb-0 text-muted">Fresh Orange </h5>
                <p className=" text-start"><small className="text-muted">Citrusy and juicy, a burst of vitamin C.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={grapes} class="img-fluid rounded-start mx-auto d-block" alt="grapes" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start mb-0 fw-bold lead text-muted"> Green Grapes </h5>
                <p className=" text-start"><small className="text-muted">Small and sweet, nature's bite-sized treats.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={guava} class="img-fluid rounded-start mx-auto d-block" alt="guava" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Ripe Guava </h5>
                <p className=" text-start"><small className="text-muted"> Crisp and tropical, a sweet treat in the late winter.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={mango} class="img-fluid rounded-start mx-auto d-block" alt="apple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted fw-bold mb-0">Fresh Ripe Mango </h5>
                <p className=" text-start"><small className="text-muted">Sweet and tropical, a juicy indulgence.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={pomegranate} class="img-fluid rounded-start mx-auto d-block" alt="apple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Pomegranate</h5>
                <p className=" text-start"><small className="text-muted">Jewel-like seeds, bursting with antioxidants.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={papaya} class="img-fluid rounded-start mx-auto d-block" alt="papaya" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Papaya</h5>
                <p className=" text-start"><small className="text-muted">Sweet and succulent, taste of the monsoon.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={coconut} class="img-fluid rounded-start mx-auto d-block" alt="coconut" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Coconut</h5>
                <p className=" text-start"><small className="text-muted">  Nutty and versatile, a staple ingredient </small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={pineapple} class="img-fluid rounded-start mx-auto d-block" alt="pineapple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted fw-bold mb-0">Fresh PineApple</h5>
                <p className=" text-start"><small className="text-muted"> Tangy and tropical a perfect addition to spring. </small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={lemon} class="img-fluid rounded-start mx-auto d-block" alt="orage/lemon" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted fw-bold mb-0">Fresh CrutsFruits</h5>
                <p className=" text-start"><small className="text-muted">angy and tropical, a perfect addition to spring.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </SwiperSlide>
      </Swiper>
        </div>
       </>
    );
}
export default Banner;